module.exports = __webpack_public_path__ + "img/stock-vector.7d694e1d.png";